import { render } from "./calculator.vue?vue&type=template&id=0979139f"
import script from "./calculator.vue?vue&type=script&lang=js"
export * from "./calculator.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__